import { Button, Modal } from "react-bootstrap";
import { BsExclamationTriangle } from "react-icons/bs";

import CustomAlert from "./CustomAlert";
import { ErrorBoundary } from "./ErrorBoundary";

interface Props {
  children: React.ReactNode;
  type?: "modal" | "redo";
}

export function ErrorBoundaryModal({ children, type }: Props) {
  return (
    <ErrorBoundary
      render={({ errorMessage, closeError, errorDetails }) => {
        if (type === "modal") {
          return (
            <Modal show size="lg">
              <Modal.Header>
                <Modal.Title>
                  <span className="modal-title-icon me-1">
                    <BsExclamationTriangle color="red" />
                  </span>
                  Ett fel har uppstått
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p style={{ whiteSpace: "pre-wrap" }}>{errorMessage}</p>
                {errorDetails && <pre>{errorDetails}</pre>}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={closeError}>
                  Stäng
                </Button>
              </Modal.Footer>
            </Modal>
          );
        }

        return (
          <CustomAlert
            content={
              <>
                <p style={{ whiteSpace: "pre-wrap" }}>{errorMessage}</p>
                {errorDetails && <pre>{errorDetails}</pre>}
                <Button variant="secondary" onClick={closeError}>
                  Stäng
                </Button>
              </>
            }
            title="Ett fel har uppstått"
          />
        );
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
